import { render, staticRenderFns } from "./Browse.Header.vue?vue&type=template&id=7e7ff014&scoped=true&"
import script from "./Browse.Header.vue?vue&type=script&lang=js&"
export * from "./Browse.Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7ff014",
  null
  
)

export default component.exports